import { useEffect } from 'react'

import { useUserApiSwrSessionV1Customer } from '../../user-data'

type CustomerFieldName = 'email' | 'firstName' | 'lastName' | 'phoneNumber'

type SetCustomerFieldValue = (name: CustomerFieldName, value: string) => void

export const useDirectContactFormPrefillCustomerData = (
  setValue: SetCustomerFieldValue,
): {
  isCustomerDataComplete: boolean
  isCustomerLoggedIn: boolean
} => {
  const { data: customerData } = useUserApiSwrSessionV1Customer()
  const isCustomerLoggedIn = Boolean(customerData?.customerNumber)
  const isCustomerDataComplete = Boolean(
    customerData?.email && customerData.firstName && customerData.lastName,
  )

  useEffect(() => {
    if (!isCustomerLoggedIn || !customerData) {
      return
    }

    setValue('email', customerData.email ?? '')
    setValue('firstName', customerData.firstName ?? '')
    setValue('lastName', customerData.lastName ?? '')
    setValue('phoneNumber', customerData.phone ?? '')
  }, [customerData, isCustomerLoggedIn, setValue])

  return {
    isCustomerDataComplete,
    isCustomerLoggedIn,
  }
}
